"use client";
import { jsx, jsxs } from "react/jsx-runtime";
import CloseSmall from "@crehana/compass.icons.outline/CloseSmall";
import { cn } from "../utils.js";
import * as __rspack_external_react from "react";
import * as __rspack_external__radix_ui_react_dialog_dabd8325 from "@radix-ui/react-dialog";
const Dialog = __rspack_external__radix_ui_react_dialog_dabd8325.Root;
const DialogTrigger = __rspack_external__radix_ui_react_dialog_dabd8325.Trigger;
const DialogPortal = __rspack_external__radix_ui_react_dialog_dabd8325.Portal;
const DialogClose = __rspack_external__radix_ui_react_dialog_dabd8325.Close;
const DialogOverlay = /*#__PURE__*/ __rspack_external_react.forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ jsx(__rspack_external__radix_ui_react_dialog_dabd8325.Overlay, {
        ref: ref,
        className: cn('tw-fixed tw-inset-0 tw-z-dialog tw-bg-neutral-light-800 tw-opacity-50 tw-backdrop-blur-sm data-[state=open]:tw-animate-in data-[state=closed]:tw-animate-out data-[state=closed]:tw-fade-out-0 data-[state=open]:tw-fade-in-0', className),
        ...props
    }));
DialogOverlay.displayName = __rspack_external__radix_ui_react_dialog_dabd8325.Overlay.displayName;
const DialogContent = /*#__PURE__*/ __rspack_external_react.forwardRef(({ className, hideClose, children, size = 'sm', ...props }, ref)=>/*#__PURE__*/ jsxs(DialogPortal, {
        children: [
            /*#__PURE__*/ jsx(DialogOverlay, {}),
            /*#__PURE__*/ jsxs(__rspack_external__radix_ui_react_dialog_dabd8325.Content, {
                ref: ref,
                className: cn('tw-fixed tw-left-[50%] tw-top-[50%] tw-rounded tw-max-w-[327px] tw-z-dialog tw-w-full tw-translate-x-[-50%] tw-translate-y-[-50%] tw-bg-neutral-light-100 tw-duration-200', 'data-[state=closed]:tw-fade-out-0 data-[state=open]:tw-fade-in-0 data-[state=closed]:tw-zoom-out-95 data-[state=open]:tw-zoom-in-95', 'dark:tw-bg-elevation-dark-00 dark:tw-text-neutral-light-100', 'tw-max-h-[calc(100vh-2.4rem)] tw-overflow-auto', 'sm' === size && 'sm:tw-max-w-[564px]', 'md' === size && 'sm:tw-max-w-[760px]', 'lg' === size && 'sm:tw-max-w-[980px]', 'xl' === size && 'sm:tw-max-w-[115rem]', className),
                onPointerDownOutside: (e)=>{
                    if (e.target instanceof Element && e.target.closest('[data-sonner-toast]')) e.preventDefault();
                },
                ...props,
                children: [
                    children,
                    !hideClose && /*#__PURE__*/ jsxs(__rspack_external__radix_ui_react_dialog_dabd8325.Close, {
                        className: "tw-absolute tw-right-1.2 tw-top-1.2 transition-opacity disabled:tw-pointer-events-none",
                        children: [
                            /*#__PURE__*/ jsx(CloseSmall, {
                                size: 24,
                                className: "tw-text-neutral-light-700"
                            }),
                            /*#__PURE__*/ jsx("span", {
                                className: "tw-sr-only",
                                children: "Close"
                            })
                        ]
                    })
                ]
            })
        ]
    }));
DialogContent.displayName = __rspack_external__radix_ui_react_dialog_dabd8325.Content.displayName;
const DialogHeader = ({ className, ...props })=>/*#__PURE__*/ jsx("div", {
        className: cn('tw-px-2.4 tw-pt-2.4 tw-space-y-1.6 tw-text-center', className),
        ...props
    });
DialogHeader.displayName = 'DialogHeader';
const DialogFooter = ({ className, ...props })=>/*#__PURE__*/ jsx("div", {
        className: cn('tw-py-2 tw-px-2.4 tw-text-center tw-rounded-b tw-space-x-0.8 tw-border-t tw-border-solid', 'tw-bg-neutral-light-300 tw-border-neutral-light-400 dark:tw-bg-neutral-dark-700 dark:tw-border-neutral-dark-600', className),
        ...props
    });
DialogFooter.displayName = 'DialogFooter';
const DialogTitle = /*#__PURE__*/ __rspack_external_react.forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ jsx(__rspack_external__radix_ui_react_dialog_dabd8325.Title, {
        ref: ref,
        className: cn('tw-font-h5 tw-line-clamp-2 tw-font-semibold', className),
        ...props
    }));
DialogTitle.displayName = __rspack_external__radix_ui_react_dialog_dabd8325.Title.displayName;
const DialogDescription = /*#__PURE__*/ __rspack_external_react.forwardRef(({ className, ...props }, ref)=>/*#__PURE__*/ jsx(__rspack_external__radix_ui_react_dialog_dabd8325.Description, {
        ref: ref,
        className: cn('tw-font-body4 tw-px-2 tw-pt-1.2 tw-pb-2.4 tw-line-clamp-3 tw-text-center', className),
        ...props
    }));
DialogDescription.displayName = __rspack_external__radix_ui_react_dialog_dabd8325.Description.displayName;
export { Dialog, DialogClose, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogOverlay, DialogPortal, DialogTitle, DialogTrigger };
